module.exports = __webpack_public_path__ + "static/media/header-1.207f44b8.gif";